import { ConfigSvcProps } from '..';
import CommonJobSvcSpec from '../common/CommonJobSvcSpec';
import CommonJobSvcOption from '../common/CommonJobSvcOption';
import CommonJobSvcInstructions from '../common/CommonJobSvcInstructions';
import CommonJobSvcMessage from '../common/CommonJobSvcMessage';
import CommonJobSvcName from '../common/CommonJobSvcName';
import { useHideSvc } from '../hook/useHideSvc';
import CommonQuantityPerBundle from '../common/CommonQuantityPerBundle';
import CommonJobSvcBorder from '../common/CommonJobSvcBorder';
import CommonJobSvcCotainer from '../common/CommonJobSvcCotainer';
import { useHideSvcContainer } from '../hook/useHideSvcContainer';
import RevxFlexLayout from 'components/RevxFlexLayout';

const DieCut = (props: ConfigSvcProps) => {
  const hideSvc = useHideSvc(props);

  const hideSvcContainer = useHideSvcContainer(props);

  return (
    <>
      <div style={hideSvc}>
        <RevxFlexLayout align="top" justify="justify-start">
          <CommonJobSvcName {...props} />
          <CommonJobSvcCotainer {...props}>
            <CommonJobSvcSpec {...props} disabled={hideSvcContainer} />
            <CommonJobSvcOption {...props} disabled={hideSvcContainer} />
            <CommonQuantityPerBundle {...props} disabled={hideSvcContainer} />
            <CommonJobSvcInstructions {...props} disabled={hideSvcContainer} />
            <CommonJobSvcMessage {...props} disabled={hideSvcContainer} />
          </CommonJobSvcCotainer>
        </RevxFlexLayout>
        <CommonJobSvcBorder />
      </div>
    </>
  );
};

export default DieCut;
